import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBk-Rg10eaE_r8kKGglpIPX5RNIVpAH530",
  authDomain: "currentlyremote-76979.firebaseapp.com",
  databaseURL: "https://currentlyremote-76979-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "currentlyremote-76979",
  storageBucket: "currentlyremote-76979.appspot.com",
  messagingSenderId: "656392256240",
  appId: "1:656392256240:web:41ebc0bb472510d9526035",
  measurementId: "G-Z3T18BLPS5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Initialize Firebase Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}
export { analytics };

export default app;

